import { render, staticRenderFns } from "./visitor.vue?vue&type=template&id=36134ae6&scoped=true&"
import script from "./visitor.vue?vue&type=script&lang=js&"
export * from "./visitor.vue?vue&type=script&lang=js&"
import style0 from "./visitor.vue?vue&type=style&index=0&id=36134ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36134ae6",
  null
  
)

component.options.__file = "visitor.vue"
export default component.exports